let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i6UiL")).then(() => parcelRequire('7l6f4'));